// extracted by mini-css-extract-plugin
export default {"form":"Checkout_form__5MvZq","control":"Checkout_control__Vaktq","actions":"Checkout_actions__LSLqp","submit":"Checkout_submit__OSgrX","invalid":"Checkout_invalid__EpXN7"};